export * from './lib/kanzi-prime-ui.module';
export * from 'primeng/api';
// export * from 'primeng/fullcalendar';
export * from 'primeng/utils';
